const isEnabledFrontmatterFlag = (value: unknown): boolean => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') return value.trim().toLowerCase() === 'true'
  return false
}

export const isDraftPost = (draft: unknown): boolean => isEnabledFrontmatterFlag(draft)

export const isHiddenPost = (hidden: unknown): boolean => isEnabledFrontmatterFlag(hidden)
